/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { updateDefaultAirport } from './redux/actions';
import Loading from '../../loading/loading';

import styles from './airports.module.scss';

class AirportSelection extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.state = {
      airportsDropdown: false,
      loadingStatus: false
    };
  }

  componentDidMount() {
    if (performance.navigation.type === 1) {
      this.setState({ loadingStatus: false });
    }
  }

  componentWillReceiveProps(nextprops) {
    if (nextprops.apiStatusUser?.success === true) {
      this.setState({ loadingStatus: false }, () => {
        window.location.reload();
      });
    }
  }

  handleOutsideClick(e) {
    // ignore clicks on the component itself
    try {
      if (this.node.contains(e.target)) {
        return;
      }
      this.handleClick(
      );
    } catch (ex) {
      // nothing
    }
  }

  handleClick() {
    const { airportsDropdown } = this.state;
    if (!airportsDropdown) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
    this.setState(prevState => ({
      airportsDropdown: !prevState.airportsDropdown
    }));
  }

  async changeDefaultAirport(portal_airport) {
    const { updateDefaultAirportFun } = this.props;
    localStorage.setItem('airportId', portal_airport.code);
    updateDefaultAirportFun(portal_airport);
    this.setState({ loadingStatus: true });
  }

  render() {
    const { airportsDropdown, loadingStatus } = this.state;
    const { profile } = this.props;
    const { portal_airport, portal_authorized_airports } = profile;
    localStorage.setItem('aerosimpleAirportNameAndIataCode', `${portal_airport.name}%@%${portal_airport.iata_code}`);
    const airport_list = [];
    if (portal_authorized_airports) {
      portal_authorized_airports.forEach((auth_airport) => {
        airport_list.push(
          <li className={styles.item} key={auth_airport.code}>
            <button type="button" onClick={() => this.changeDefaultAirport(auth_airport)} style={{ color: 'black' }}>
              {auth_airport.name}
            </button>
          </li>
        );
      });
    }
    return (
      <div className={styles.airports} ref={(node) => { this.node = node; }}>
        <button type="button" onClick={this.handleClick}>
          { portal_airport.name }
        </button>
        {airportsDropdown && airport_list.length > 1 && (
          <ul className={`${styles.dropdown} ${airportsDropdown ? styles.open : ''}`}>
            {airport_list}
          </ul>
        )}
        <Loading loadingStatus={loadingStatus} />
      </div>
    );
  }
}

AirportSelection.propTypes = {
  profile: PropTypes.shape({
    email: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    portal_authorized_airports: PropTypes.array,
    portal_airport: PropTypes.object
  }).isRequired
};
const mapStateToProps = state => ({
  action: state.updateairport?.action,
  apiStatusUser: state.updateairport?.apiStatusUser
});
const mapDispatchToProps = dispatch => ({
  updateDefaultAirportFun: (portal_airport) => {
    dispatch(updateDefaultAirport(portal_airport.id));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AirportSelection));
